import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../component/Loader";

const useCondonationToken = () => {
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    setIsRedirecting(true);

    // ePay usually returns params in the hash/query after redirect
    const params = new URLSearchParams(window.location.hash.split("?")[1]);

    const transaction_id = params.get("txnid");
    const semester = params.get("semester");
    const accountid = params.get("accountid");


    // Save only what we need
    localStorage.setItem("transaction_id", transaction_id || "");
    localStorage.setItem("semester", semester || "");
    localStorage.setItem("accountid", accountid || "");


    if (transaction_id && semester && accountid) {
      // ✅ valid → redirect to condonation success/summary page
      setTimeout(() => {
        const baseUrl = window.location.origin;
        const newUrl = baseUrl + "/#/condonationPayment";
        window.location.href = newUrl;
      }, 1000);
    } else {
      // ❌ invalid response → redirect back to condonation form
      localStorage.setItem("condonation_error", "Payment validation failed");
      const baseUrl = window.location.origin;
      const newUrl = baseUrl + "/#/condonation";
      window.location.href = newUrl;
    }
  }, [navigate]);

  return isRedirecting;
};

export default function StudentCondonationPayResponse() {
  const isRedirecting = useCondonationToken();

  return isRedirecting ? <Loader /> : null;
}
